import React, { createContext } from 'react';

const IndexData = createContext({});

export { IndexData };
